import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import GoogleOptimizeHead from "../../components/google-optimize-head/google-optimize-head";
import Loading from "../../components/loading/loading";
import {
    ROUTE_APP_EMPTY,
    ROUTE_APP_QUOTATION,
    ROUTE_APP_SUMMARY,
} from "../../constants/routes/app";
import { useChannel } from "../../libs/channels/hooks/use-channel";
import PayrollErrorModal from "../payroll-error-modal/payroll-error-modal";
import { PrivateRoute } from "./components/private-route";
import { usePageBootstrap } from "./hooks/use-page-boostrap";

const Landing = lazy(() => import("../landing/landing"));
const Quotation = lazy(() => import("../quotation/quotation"));
const Summary = lazy(() => import("../summary/summary"));

const siteInMaintenance = Number(
    process.env.REACT_APP_SITE_IN_MAINTENANCE || 0
);

const AppRoutes: React.FC = () => {
    usePageBootstrap();
    const { toChannelsPath, isBcpTheme } = useChannel();
    return (
        <Suspense fallback={<Loading />}>
            <GoogleOptimizeHead isBcpTheme={isBcpTheme} />
            <Switch>
                <Route
                    path={toChannelsPath(ROUTE_APP_EMPTY)}
                    exact
                    component={Landing}
                />
                <PrivateRoute
                    path={toChannelsPath(ROUTE_APP_QUOTATION)}
                    component={Quotation}
                />
                <PrivateRoute
                    path={toChannelsPath(ROUTE_APP_SUMMARY)}
                    component={Summary}
                />
            </Switch>
            <PayrollErrorModal />
        </Suspense>
    );
};

const RoutesMaintenance = () => (
    <Switch>
        <Route
            path="*"
            render={() =>
                (window.location.href = `https://web.pacificoseguros.com/canales/servicios/solicitudes/vida-ley`)
            }
        />
    </Switch>
);
const routes = siteInMaintenance ? <RoutesMaintenance /> : <AppRoutes />;
export default routes;
